<template>
  <div
    class="cheesy-reward col-sm-6 mb32"
    v-if="
      getUserData?.rewardType == 'CHEESY' &&
      rewardTypeEligibleInCurrentStore &&
      getCheesyRewardIconPath
    "
    id="cheesy_rewards_widget"
  >
    <h3 class="fs-18 lh21 bold mb12">Cheesy Rewards</h3>
    <Observer :options="{ rootMargin: '-50px' }" @intersect="itisvisible" />
    <!-- non enrolled user -->
    <div class="un-enrolled flex-column" v-if="!getUserData.isEnrolled">
      <div class="flex-row">
        <img :src="getCheesyRewardIconPath" class="pd10" />
        <div class="ml10 pd12">
          <h3 class="bold fs-14 lh20 mb6">Earn points towards FREE PIZZAS!</h3>
          <p class="fs-12 lh18 mr30">
            1 Order = {{getUserData.rewardData.pointsPerOrder}} Points<br />
            {{getUserData.rewardData.itemRedeemPoints}} Points = 1 Free Pizza
          </p>
        </div>
      </div>
      <div class="rwd-bottom flex-row pd10">
        <h3 class="fs-11 ml10">Enroll now & start collecting points</h3>
        <button
          class="btn medium pt6 pb6 pr12 pl12"
          @click="gotoEnroll($event)"
        >
          Enroll now
        </button>
      </div>
    </div>
    <!-- already enrolled user -->
    <div class="enrolled flex-row" v-if="getUserData.isEnrolled">
      <div class="flex-column left pd12">
        <div
          class="cheesy-reward-widget-image ml5 mb4"
          v-bind:style="{
            backgroundImage: `url('` + getCheesyRewardIconPath + `')`,
          }"
        >
          <p class="bold" v-if="getUserData.rewardData.elizibleForPizza">
            {{
              Math.floor(
                getUserData.rewardData.points / getUserData.rewardData.maxPoints
              )
            }}
          </p>
        </div>

        <h3
          class="fs-12 lh13 bold"
          v-if="!getUserData.rewardData.elizibleForPizza"
        >
          {{ getUserData.rewardData.points }}/{{
            getUserData.rewardData.maxPoints
          }}
        </h3>
        <h3 class="fs-12 lh13" v-if="!getUserData.rewardData.elizibleForPizza">
          Points
        </h3>
        <h3 class="fs-12 lh13" v-if="getUserData.rewardData.elizibleForPizza">
          Redeem
        </h3>
        <h3 class="fs-12 lh13" v-if="getUserData.rewardData.elizibleForPizza">
          Free Pizza
        </h3>
      </div>
      <div class="flex-column middle pd12">
        <h3
          class="bold fs-14 lh20 mt5"
          v-if="!getUserData.rewardData.elizibleForPizza"
        >
          You are
          {{ getUserData.rewardData.maxPoints - getUserData.rewardData.points }}
          points away from a free pizza.
        </h3>
        <h3
          class="bold fs-14 lh20 mt5"
          v-if="getUserData.rewardData.elizibleForPizza"
        >
          Time to Redeem your FREE Pizzas!
        </h3>
        <p
          class="fs-12 lh17 mb5 bold enrolled-points-cta"
          v-if="!getUserData.rewardData.elizibleForPizza"
          @click="goto($event)"
        >
          Place order to earn points
        </p>
        <button
          class="btn medium pt6 pb6 pr12 pl12"
          v-if="getUserData.rewardData.elizibleForPizza"
          @click="gotoPizzaAvail($event)"
        >
          Select Free Pizza
        </button>
      </div>
      <i
        class="jfi-arrow-line right pd12 color-secondary"
        @click="gotoPizzaLoyalyInfo($event)"
      ></i>
    </div>
  </div>
</template>

<script>
import { keyMapsGetter } from "../helpers/storeKeys";
import {
  staticImgBaseUrl,
  v2PwaBasePath,
  projectBasePathWithFolder,
} from "../config/apiEndpoints";
import Utility from "../helpers/utility";
import setEvents from "../helpers/events";
import Observer from "../assets/Observer.vue";
import LocalStorageFunc from "../helpers/localStorageFunc";
import {
  VWO_NEXTGEN_HOMEPAGE_EXPERIMENT,
  VWO_NEXTGEN_EXPERIMENT_VARIANTS,
} from "../config/vwoKeys";

export default {
  name: "CheesyRewards",

  components: {
    Observer,
  },

  data() {
    return {
      staticImgBaseUrl: staticImgBaseUrl,
      isUpdated: false,
    };
  },
  mounted() {
    //
  },
  methods: {
    itisvisible() {
      if(!this.isUpdated && ( this.rewardTypeEligibleInCurrentStore && this.getCheesyRewardIconPath)) {
        this.eventFunction(false);
        this.isUpdated = true;
      }
    },
    eventFunction(isClicked = false, eObj = {}) {
      if (this.getUserData?.rewardType == "CHEESY") {
        let preEventObj = {};
        if (!this.getUserData?.isEnrolled) {
          preEventObj = {
            category: "cheesyrewards",
            enrollmentStatus: "no",
            ...eObj,
          };
        } else if (this.getUserData?.isEnrolled) {
          if (!this.getUserData?.rewardData?.elizibleForPizza) {
            preEventObj = {
              subCategory: "place order to earn points",
              category: "cheesyrewards",
              enrollmentStatus: "yes",
              points: this.getUserData?.rewardData?.points,
              ...eObj,
            };
          } else {
            preEventObj = {
              subCategory: "select free pizza",
              category: "cheesyrewards",
              enrollmentStatus: "yes",
              points: this.getUserData?.rewardData?.points,
              ...eObj,
            };
          }
        }

        let eventType = isClicked ? "Click" : "Impression";
        let userAction = isClicked ? "click" : "impression";
        const eventObj = Utility.amplitudeEventObj(
          userAction,
          "cheesy banner",
          "10",
          preEventObj
        );
        setEvents("amplitude", eventType, eventObj);
      }
    },
    gotoEnroll(event, item) {
      this.eventFunction(true, { subCategory: "enrollnow", points: "0" });
      window.location.href = `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}pizzaLoyalty`;
    },
    goto() {
      this.eventFunction(true);
      if (this.isSeparateMenuVariant) {
        let url =
          projectBasePathWithFolder +
          Utility.getMenuCategory() +
          LocalStorageFunc.storeId() +
          Utility.getUrlQueryString();
        url = Utility.addUpdateParam(url, "showSearchModal", false);
        url = Utility.addUpdateParam(url, "scrollTo", "menuTop");
        window.location.href = url;
      } else {
        let itmId =
          this.getBottomBarData[Object.keys(this.getBottomBarData)[0]]
            ?.categoryId;
        if (itmId) {
          Utility.scrollUptoTo("element_catg_" + itmId);
        } else {
          Utility.scrollUptoTo("pageTop");
        }
      }
    },
    gotoPizzaAvail(event, item) {
      this.eventFunction(true);
      window.location.href = `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}pizzaLoyalty`;
      // window.location.href = `${v2PwaBasePath}/MenuLoyalty?fp=${
      //   this.$store.getters[keyMapsGetter.GET_USER_DATA].rewardData
      //     .elizibleForPizza
      // }`;
    },
    gotoPizzaLoyalyInfo(event, item) {
      this.eventFunction(true, { subCategory: "arrow click" });
      window.location.href = `${v2PwaBasePath}/${window?._siteProps_?.props?.postorderUIBasepath}pizzaLoyalty`;
    },
  },

  computed: {
    getBottomBarData() {
      return this.$store.getters[keyMapsGetter.GET_PRODUCT_ITEM_FOR_BOTTOMBAR];
    },
    getUserData() {
      return this.$store.getters[keyMapsGetter.GET_USER_DATA];
    },
    getCheesyRewardIconPath() {
      return this.$store.getters[keyMapsGetter.GET_CHEESY_REWARD_ICON_PATH];
    },
    rewardTypeEligibleInCurrentStore() {
      let userData = this.$store.getters[keyMapsGetter.GET_USER_DATA];
      let storeDetails = this.$store.state.Location.storeDetails;
      if (userData?.rewardType == "CHEESY") {
        if (
          storeDetails?.loyaltyProgramCodes?.includes("POTP1") ||
          storeDetails?.loyaltyProgramCodes?.includes("POTP2")
        ) {
          return true;
        }
      }
      return false;
    },
    isSeparateMenuVariant() {
      let exp = this.$store.state.Config.vwoExperiments;
      if (
        exp?.[VWO_NEXTGEN_HOMEPAGE_EXPERIMENT] ===
        VWO_NEXTGEN_EXPERIMENT_VARIANTS.VARIANT_U
      ) {
        return true;
      } else {
        return false;
      }
    },
  },
};
</script>

<style scoped></style>
